import { call, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './QuickshopWebActions';
import * as AuthActions from '../authorization/AuthUserActions';
import { actions } from './QuickshopWebReducer';
import { addLoadingMessage, removeLoadingMessage } from '../app/AppActions';
import { ACCESS_DENIED_CODE } from 'configs/constants';
import * as Api from 'api/QuickshopWebApi';
import { getText } from 'helpers/app/getText';

export function* attemptUpdateQuickshop({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:UPDATING_QUICKSHOP')));
    yield call(Api.attemptUpdateQuickshop, data);
    yield put(Actions.attemptUpdateQuickshopSucceed());
    yield put(removeLoadingMessage(getText('notifications:UPDATING_QUICKSHOP')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptUpdateQuickshopFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:UPDATING_QUICKSHOP')));
  }
}

export function* attemptStartRental({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:STARTING_RENTAL')));
    const response = yield call(Api.attemptStartRental, data);
    yield put(Actions.attemptStartRentalSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:STARTING_RENTAL')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptStartRentalFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:STARTING_RENTAL')));
  }
}

export function* attemptEndRental({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:ENDING_RENTAL')));
    yield call(Api.attemptEndRental, data);
    yield put(Actions.attemptEndRentalSucceed());
    yield put(removeLoadingMessage(getText('notifications:ENDING_RENTAL')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptEndRentalFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:ENDING_RENTAL')));
  }
}

export function* attemptGetMeasurementData({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:GETTING_MEASUREMENT_DATA')));
    const response = yield call(Api.attemptGetMeasurementData, data);
    yield put(Actions.attemptGetMeasurementDataSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_MEASUREMENT_DATA')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptGetMeasurementDataFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:GETTING_MEASUREMENT_DATA')));
  }
}

export function* attemptLinkQuickshop({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:LINKING_QUICKSHOP')));
    yield call(Api.attemptLinkQuickshop, data);
    yield put(Actions.attemptLinkQuickshopSucceed());
    yield put(removeLoadingMessage(getText('notifications:LINKING_QUICKSHOP')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied(data));
    } else {
      yield put(Actions.attemptLinkQuickshopFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:LINKING_QUICKSHOP')));
  }
}

export function* attemptGetReceiptData({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:GETTING_RECEIPT_DATA')));
    const response = yield call(Api.attemptGetReceiptData, data);
    yield put(Actions.attemptGetReceiptDataSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_RECEIPT_DATA')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied(data));
    } else {
      yield put(Actions.attemptGetReceiptDataFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:GETTING_RECEIPT_DATA')));
  }
}

export function* attemptGetPOSSession({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:GETTING_POS_SESSION')));
    const response = yield call(Api.attemptGetPOSSession, data);
    yield put(Actions.attemptGetPOSSessionSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_POS_SESSION')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied(data));
    } else {
      yield put(Actions.attemptGetPOSSessionFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:GETTING_POS_SESSION')));
  }
}

export function* attemptGetTopMeasurementData({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:GETTING_TOP_MEASUREMENT_DATA')));
    const response = yield call(Api.attemptGetTopMeasurementData, data);
    yield put(Actions.attemptGetTopMeasurementDataSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_TOP_MEASUREMENT_DATA')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied(data));
    } else {
      yield put(Actions.attemptGetTopMeasurementDataFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:GETTING_TOP_MEASUREMENT_DATA')));
  }
}

export function* attemptStartPOSSession({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:STARTING_POS_SESSION')));
    const response = yield call(Api.attemptStartPOSSession, data);
    if (response.data.code === 409) {
      yield put(Actions.attemptStartPOSSessionFailed(response.data));
      yield put(removeLoadingMessage(getText('notifications:STARTING_POS_SESSION')));

      return;
    }
    yield put(Actions.attemptStartPOSSessionSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:STARTING_POS_SESSION')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied(data));
    } else {
      yield put(Actions.attemptStartPOSSessionFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:STARTING_POS_SESSION')));
  }
}

export function* attemptStopPOSSession({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:STOPING_POS_SESSION')));
    yield call(Api.attemptStopPOSSession, data);
    yield put(Actions.attemptStopPOSSessionSucceed());
    yield put(removeLoadingMessage(getText('notifications:STOPING_POS_SESSION')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied(data));
    } else {
      yield put(Actions.attemptStopPOSSessionFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:STOPING_POS_SESSION')));
  }
}

export function* attemptGetBookingCart({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:GETTING_BOOKING_CART')));
    const response = yield call(Api.attemptGetBookingCart, data);
    yield put(Actions.attemptGetBookingCartSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_BOOKING_CART')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptGetBookingCartFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:GETTING_BOOKING_CART')));
  }
}

export function* attemptAddProductToCart({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:ADDING_PRODUCT_TO_CART')));
    const response = yield call(Api.attemptAddProductToCart, data);
    yield put(Actions.attemptAddProductToCartSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:ADDING_PRODUCT_TO_CART')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptAddProductToCartFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:ADDING_PRODUCT_TO_CART')));
  }
}

export function* attemptCheckSwishPaymentStatus({ payload: { data } }) {
  try {
    const response = yield call(Api.attemptCheckSwishPaymentStatus, data);
    yield put(Actions.attemptCheckSwishPaymentStatusSucceed(response.data));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    }
  }
}

export function* attemptPayPOSSession({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:PAYING_POS_SESSION')));
    const response = yield call(Api.attemptPayPOSSession, data);
    if (response.data.error) {
      yield put(Actions.attemptPayPOSSessionFailed(response.data));
    } else {
      yield put(Actions.attemptPayPOSSessionSucceed(response.data));
    }
    yield put(removeLoadingMessage(getText('notifications:PAYING_POS_SESSION')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptPayPOSSessionFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:PAYING_POS_SESSION')));
  }
}

export function* attemptGetQuickshop({ payload: { data } }) {
  try {
    yield put(addLoadingMessage(getText('notifications:GETTING_QUICKSHOP')));
    const response = yield call(Api.attemptGetQuickshop, data);
    yield put(Actions.attemptGetQuickshopSucceed(response.data));
    yield put(removeLoadingMessage(getText('notifications:GETTING_QUICKSHOP')));
  } catch ({ response: { data } }) {
    if (data.code === ACCESS_DENIED_CODE) {
      yield put(AuthActions.attemptSetAccessDenied());
    } else {
      yield put(Actions.attemptGetQuickshopFailed(data));
    }
    yield put(removeLoadingMessage(getText('notifications:GETTING_QUICKSHOP')));
  }
}

function* quickshopWebSaga() {
  yield takeLatest(actions.ATTEMPT_GET_MEASUREMENT_DATA, attemptGetMeasurementData);
  yield takeLatest(actions.ATTEMPT_GET_RECEIPT_DATA, attemptGetReceiptData);
  yield takeLatest(actions.ATTEMPT_ADD_PRODUCT_TO_CART, attemptAddProductToCart);
  yield takeLatest(actions.ATTEMPT_GET_QUICKSHOP, attemptGetQuickshop);
  yield takeLatest(actions.ATTEMPT_GET_POS_SESSION, attemptGetPOSSession);
  yield takeLatest(actions.ATTEMPT_GET_BOOKING_CART, attemptGetBookingCart);
  yield takeLatest(actions.ATTEMPT_PAY_POS_SESSION, attemptPayPOSSession);
  yield takeLatest(actions.ATTEMPT_START_POS_SESSION, attemptStartPOSSession);
  yield takeLatest(actions.ATTEMPT_STOP_POS_SESSION, attemptStopPOSSession);
  yield takeLatest(actions.ATTEMPT_LINK_QUICKSHOP, attemptLinkQuickshop);
  yield takeLatest(actions.ATTEMPT_START_RENTAL, attemptStartRental);
  yield takeLatest(actions.ATTEMPT_END_RENTAL, attemptEndRental);
  yield takeLatest(actions.ATTEMPT_GET_TOP_MEASUREMENT_DATA, attemptGetTopMeasurementData);
  yield takeLatest(actions.ATTEMPT_CHECK_SWISH_PAYMENT_STATUS, attemptCheckSwishPaymentStatus);
  yield takeLatest(actions.ATTEMPT_UPDATE_QUICKSHOP, attemptUpdateQuickshop);
}

export default quickshopWebSaga;
